import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ActionsSearchIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M23.251 24c-.199 0-.39-.079-.53-.22l-6.519-6.52c-1.777 1.53-4.044 2.37-6.388 2.366-5.411 0-9.813-4.402-9.814-9.812C0 4.403 4.401.001 9.812 0c5.411 0 9.814 4.402 9.814 9.812 0 2.356-.837 4.61-2.364 6.387l6.52 6.521c.142.14.222.33.222.53s-.08.39-.222.53c-.14.14-.332.22-.531.22zM9.814 1.5c-2.207-.006-4.324.87-5.88 2.435C2.37 5.491 1.494 7.608 1.5 9.814c-.006 2.206.871 4.322 2.435 5.878 1.556 1.564 3.672 2.44 5.878 2.434 2.214 0 4.295-.86 5.864-2.42l.031-.031c1.554-1.554 2.425-3.665 2.418-5.863 0-4.583-3.728-8.312-8.312-8.312z" transform="translate(-.001)"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ActionsSearchIcon = __decorateClass([
  customElement("elm-actions-search-icon")
], ActionsSearchIcon);
export { ActionsSearchIcon };
